import React from "react";
import CallButton from "./CallButton";

const RoundAnswerButton = ({ text, onClick }) => (
  <CallButton size="large" onClick={onClick} buttonText={text} />
);

export default RoundAnswerButton;






// WEBPACK FOOTER //
// ./src/components/buttons/RoundAnswerButton.jsx